import { render, staticRenderFns } from "./SubFields.vue?vue&type=template&id=76984742&scoped=true&"
import script from "./SubFields.vue?vue&type=script&lang=js&"
export * from "./SubFields.vue?vue&type=script&lang=js&"
import style0 from "./SubFields.vue?vue&type=style&index=0&id=76984742&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76984742",
  null
  
)

export default component.exports